import { format } from 'date-fns'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import React, { useContext, useMemo } from 'react'
import { Icon } from 'semantic-ui-react'

export const FeedSquares = ({ allFeeds, handleSelect }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info } = sportsSeason_state ?? {}
  const { _sportsModeSport } = currentSeason_info ?? {}

  const _allFeeds = useMemo(() => {
    if (_.isEmpty(allFeeds)) return {}

    const [sports, other] = _.partition(
      _.toPairs(allFeeds),
      ([, rssFeed]) =>
        rssFeed?.categories?.includes(_sportsModeSport) ||
        rssFeed?.link?.includes(_sportsModeSport) ||
        rssFeed?.title?.includes(_sportsModeSport)
    )
    return _.fromPairs([...sports, ...other])
  }, [allFeeds, _sportsModeSport])

  const externals = {
    rss: (url) => window.open(url, '_blank')
  }

  const handleClick = (item) => {
    externals.rss(item.link)
  }

  const fnAlt_feed = (item) => {
    return <div
      style={{ display: 'flex', columnGap: '.5em' }}
      onClick={(e) => { handleSelect && handleSelect(e, item) }}>
      <Icon
        name={item._selected ? 'check circle outline' : 'circle outline'}
        color={item._selected ? 'green' : 'grey'}
        style={{ marginRight: '.5em' }} />
    </div>

  }

  const fnSubb = (item) => {
    const { content, contentSnippet, enclosures } = item
    const { url } = enclosures || {}
    const isUrl = /^https?:\/\//i.test(url?.trim())

    if (isUrl) {
      // console.log('item', item)
      const _url = url.replace('https://https://', 'https://')
      return (
        <div
          style={{
            width: '100%',
            maxWidth: '100%'
          }}
          className="rssContent sqr-box-sub"
        >
          <img
            src={_url}
            alt=""
            style={{
              display: 'block',
              width: '100%',
              height: 'auto'
            }}
          />
        </div>
      )
    }

    return (
      <div
        style={{
          width: '100%',
          maxWidth: '100%',
          overflowWrap: 'anywhere'
        }}
        className="rssContent sqr-box-sub"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }

  const fnSub = (item) => {
    const { author, pubDate } = item
    const formattedDate = format(new Date(pubDate), 'MM/dd/yyyy');
    return <div style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
      <div>{author}</div>
      <div>{formattedDate}</div>
      {fnSubb(item)}
    </div>
  }


  if (!_.isEmpty(allFeeds)) {
    return <Wrapper
      content={<ItemMenuSquares
        menuItems={_allFeeds}
        imsType={_imsTypes.inline}
        fn_altContent={fnAlt_feed}
        // fn_subContentt={fnSubb}
        fn_subContent={fnSub}
        noItemIcon={true}
        onClick={handleClick}
      />}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>
  }
}
